import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import { ReactComponent as Email } from 'images/icons/email2.svg'
import { ReactComponent as Facebook } from 'images/icons/facebook.svg'
import { ReactComponent as Instagram } from 'images/icons/instagram.svg'
import { ReactComponent as Linkedin } from 'images/icons/linkedin.svg'
import { withSnackbar } from 'notistack'
import React, { Component, Fragment } from 'react'
import QRCode from 'react-qr-code'
import { connect } from 'react-redux'
import Logo from '../../../images/logo.png'
import LogoLogin from '../../../images/logo_login.png'
import { userLogout } from '../../../store/actions'

import {
	firstLogin,
	forgotPassword,
	userLogin,
	verifyCode,
} from '../../../store/actions/auth/email'
import { userAD } from '../../../store/actions/auth/login'
import { Dialog } from '../../parts'
import { Form, Image, TextField } from '../../styled'
import {
	BackImage,
	Container,
	ContainerForm,
	FormContainer,
	Header,
	LoginConfig,
	QrCodeContainer,
	Setup2FaContainer,
} from './styled'
class Login extends Component {
	constructor(props) {
		super(props)
		this.state = {
			showPassword: false,
			password: '',
			email: '',
			keepLoggedIn: false,
			isInvalid: false,
			error: {},
			email_forgot: '',
			new_password: '',
			new_passwordRepeat: '',
			notRepeat: false,
			code2fa: '',
			secret: '',
		}
		this.handleClickShowPassword = this.handleClickShowPassword.bind(this)
		this.handleChange = this.handleChange.bind(this)
		this.handleChangeSelect = this.handleChangeSelect.bind(this)
		this.handleClickOpen = this.handleClickOpen.bind(this)
		this.handleSubmit = this.handleSubmit.bind(this)
		this.handleSubmitForgot = this.handleSubmitForgot.bind(this)
		this.handleSubmitChangePass = this.handleSubmitChangePass.bind(this)
		this.handleSubmitVerify2faCode = this.handleSubmitVerify2faCode.bind(this)
		this.handleSubmitSetup2fa = this.handleSubmitSetup2fa.bind(this)
	}

	componentDidMount() {
		const SSO = new URL(window.location.href).searchParams.get('auth_sso_token')
		if (SSO) {
			this.props.loginAD(SSO, this)
		} else {
			this.props.logout()
		}
	}

	componentWillReceiveProps(nextProps) {
		const { auth } = nextProps
		if (auth.two_factor) {
			if (auth.secret) {
				this.setState(prev => ({ ...prev, secret: auth.secret }))
				this.dialogSetup2fa?.handleClickOpen()
			} else {
				this.dialogVerify2fa?.handleClickOpen()
			}
		}
	}

	handleSubmit(e) {
		e.preventDefault()
		let email = e.target.email,
			password = e.target.password

		const { isInvalid } = this.state
		const validUser = this.emailInput.validate(email)
		const validPass = this.passwordInput.validate(password)

		if (
			validUser &&
			validPass &&
			!isInvalid &&
			email.value !== 'leo.deomedesse@voicce.com.br'
		) {
			//this.dialogBlocked.handleClickOpen()
			this.props.login(email.value, password.value, this)
		}
	}

	handleSubmitForgot(e) {
		e.preventDefault()
		let email = e.target.email_forgot
		const validEmail = this.emailForgotInput.validate(email)

		if (validEmail) {
			this.props.forgot_password(email.value, this)
		}
	}

	handleSubmitChangePass(e) {
		e.preventDefault()
		const newPass = e.target.new_password,
			PassRepeat = e.target.password_repeat,
			{ email, password } = this,
			isDifferent = newPass.value !== PassRepeat.value,
			validNewPassword = this.newPasswordInput.validate(newPass),
			validRepeat = this.passwordRepeatInput.validate(PassRepeat)

		this.setState({ notRepeat: isDifferent })
		if (!isDifferent && validNewPassword && validRepeat) {
			this.props.first_login(email, password, newPass.value, PassRepeat.value)
		}
	}

	handleSubmitVerify2faCode(e) {
		e.preventDefault()
		const code = e.target.code2fa.value
		this.props.verifyCode(code)
	}

	handleSubmitSetup2fa(e) {
		e.preventDefault()
		this.dialogSetup2fa.handleClickOpen()
		this.dialogVerify2fa.handleClickOpen()
	}

	handleChange(name, value, isInvalid) {
		this[name] = value
		this.setState({ isInvalid })
	}

	handleChangeSelect(e) {
		const target = e.target
		const name = target.name
		const value = target.type === 'checkbox' ? target.checked : target.value
		this.setState({
			[name]: value,
		})
	}

	handleClickShowPassword() {
		this.setState(prevState => ({ showPassword: !prevState.showPassword }))
	}

	handleClickOpen() {
		this.setState(prevState => ({ open: !prevState.open }))
	}

	render() {
		const {
			email,
			password,
			isInvalid,
			email_forgot,
			notRepeat,
			new_passwordRepeat,
			new_password,
			code2fa,
			secret,
		} = this.state
		const { auth } = this.props
		let { t } = this.props

		return (
			<Fragment>
				<BackImage>
					<Header>
						<Image src={Logo} alt="Digitalk" width="auto" height="3rem" />
						<ul>
							<li>
								<a
									href="https://br.linkedin.com/company/digitalk-tecnologia?trk=public_profile_topc"
									target="_blank"
									rel="noopener noreferrer"
								>
									<IconButton>
										<Linkedin fill="#FFF" />
									</IconButton>
								</a>
							</li>
							<li>
								<a
									href="https://www.facebook.com/digitalkTec/"
									target="_blank"
									rel="noopener noreferrer"
								>
									<IconButton>
										<Facebook stroke="#FFF" />
									</IconButton>
								</a>
							</li>
							<li>
								<a href="mailto:contato@digitalk.com.br">
									<IconButton>
										<Email stroke="#FFF" />
									</IconButton>
								</a>
							</li>
							<li>
								<a
									href="https://www.instagram.com/digitalktec/?hl=pt-br"
									target="_blank"
									rel="noopener noreferrer"
								>
									<IconButton>
										<Instagram stroke="#FFF" />
									</IconButton>
								</a>
							</li>
						</ul>
					</Header>
					<Container height="500px" width="450px">
						<Image src={LogoLogin} alt="Digitalk" width="55%" height="auto" />
						<ContainerForm>
							<FormContainer onSubmit={this.handleSubmit}>
								<input name="hidden" type="text" style={{ display: 'none' }} />
								<TextField
									ref={el => {
										this.emailInput = el
									}}
									id="email"
									type="e-mail"
									name="email"
									isrequired="true"
									value={email}
									placeholder={t.Form.inputEmail}
									autoFocus
									errorMessage={'email' in auth && !isInvalid && auth.email}
									onChange={this.handleChange}
								/>
								<TextField
									ref={el => {
										this.passwordInput = el
									}}
									id="password"
									name="password"
									value={password}
									isrequired="true"
									showPassword={true}
									errorMessage={
										'password' in auth && !isInvalid && auth.password
									}
									placeholder={t.Form.inputPassword}
									onChange={this.handleChange}
								/>
								<LoginConfig>
									<Button
										color="primary"
										variant="text"
										type="button"
										onClick={() => {
											this.dialogForgot.handleClickOpen()
										}}
									>
										{t.Forgot.button}
									</Button>
								</LoginConfig>
								<Button variant="contained" color="secondary" type="submit">
									{t.Form.login}
								</Button>
							</FormContainer>
						</ContainerForm>
					</Container>
				</BackImage>
				<Dialog
					text={
						<Fragment>
							<p>
								Sistema bloqueado, por favor contate nosso financeiro através do
								e-mail{' '}
								<a href="mailto:financeiro@digitalk.com.br" target="_parent">
									financeiro@digitalk.com.br
								</a>{' '}
								para maiores detalhes.
							</p>
						</Fragment>
					}
					title="Erro no acesso"
					ref={el => {
						this.dialogBlocked = el
					}}
				/>
				<Dialog
					id="forgot"
					title={t.Forgot.title}
					ref={el => {
						this.dialogForgot = el
					}}
				>
					<Form width="100%" onSubmit={this.handleSubmitForgot}>
						<TextField
							ref={el => {
								this.emailForgotInput = el
							}}
							id="email_forgot"
							name="email_forgot"
							type="e-mail"
							isrequired="true"
							value={email_forgot}
							errorMessage={
								'email_forgot' in auth && !isInvalid && auth.email_forgot
							}
							label={t.Form.inputEmail}
							autoFocus
							onChange={this.handleChange}
						/>

						<div className="flex-end">
							<Button
								type="button"
								onClick={() => this.dialogForgot.handleClickOpen()}
								color="primary"
							>
								{t.Forgot.cancel}
							</Button>
							<Button type="submit" color="primary">
								{t.Forgot.submit}
							</Button>
						</div>
					</Form>
				</Dialog>

				<Dialog
					id="changePassword"
					onClose={undefined}
					text={auth.warning}
					title={t.ChangePassword.title}
					ref={el => {
						this.dialogChangePass = el
					}}
				>
					<Form width="100%" onSubmit={this.handleSubmitChangePass}>
						{auth.errors &&
							Array.isArray(auth.errors) &&
							auth.errors.map(x => <p>{x}</p>)}
						{auth.error && <p>{auth.error}</p>}
						<TextField
							ref={el => {
								this.newPasswordInput = el
							}}
							id="newPassword"
							label={t.ChangePassword.inputPassword.label}
							name="new_password"
							value={new_password}
							isrequired="true"
							type="password"
							errorMessage={
								'new_password' in auth && !isInvalid && auth.new_password
							}
							placeholder={t.ChangePassword.inputPassword.placeholder}
							onChange={this.handleChange}
						/>
						<TextField
							ref={el => {
								this.passwordRepeatInput = el
							}}
							id="password_repeat"
							label={t.ChangePassword.inputPasswordRepeat.label}
							name="password_repeat"
							type="password"
							value={new_passwordRepeat}
							isrequired="true"
							errorMessage={
								('password_repeat' in auth &&
									!isInvalid &&
									auth.password_repeat) ||
								(notRepeat && t.ChangePassword.inputPasswordRepeat.error)
							}
							placeholder={t.ChangePassword.inputPasswordRepeat.placeholder}
							onChange={this.handleChange}
						/>

						<div className="flex-end">
							<Button type="submit" color="primary">
								{t.ChangePassword.inputPasswordRepeat.submit}
							</Button>
						</div>
					</Form>
				</Dialog>

				<Dialog
					id="verifyCode2fa"
					onClose={undefined}
					title="Informe o código exibido no autenticador"
					ref={el => {
						this.dialogVerify2fa = el
					}}
				>
					<Form width="100%" onSubmit={this.handleSubmitVerify2faCode}>
						<TextField
							ref={el => {
								this.code2faInput = el
							}}
							id="code2fa"
							label="Código de 6 dígitos"
							name="code2fa"
							value={code2fa}
							isrequired="true"
							type="text"
							errorMessage={
								'twoFactorError' in auth ? auth.twoFactorError : false
							}
							onChange={this.handleChange}
						/>

						<div className="flex-end">
							<Button type="submit" color="primary">
								Enviar
							</Button>
						</div>
					</Form>
				</Dialog>

				<Dialog
					id="setup2fa"
					onClose={undefined}
					title="Vamos configurar o autenticador"
					ref={el => {
						this.dialogSetup2fa = el
					}}
				>
					{secret && (
						<Form width="100%" onSubmit={this.handleSubmitSetup2fa}>
							<Setup2FaContainer>
								<p>
									Abra o aplicativo de autenticação e escaneie o QRCode abaixo
								</p>
								<i>
									Caso não consiga escanear, copie o código e faça o cadastro
									manualmente
								</i>
								<QrCodeContainer>
									<QRCode
										value={`otpauth://totp/${this.email || 'Digitalk'}?secret=${auth.secret}&issuer=Digitalk`}
									/>
								</QrCodeContainer>
								<TextField
									id="secret2fa"
									label="Código secreto"
									value={secret}
									type="text"
									readOnly={true}
								/>
							</Setup2FaContainer>

							<div className="flex-end">
								<Button type="submit" color="primary">
									Continuar
								</Button>
							</div>
						</Form>
					)}
				</Dialog>
			</Fragment>
		)
	}
}

const mapStateToProps = state => ({
	auth: state.auth,
	t: state.i18nState.translations[state.i18nState.lang]['Login'],
})

const mapDispatchToProps = dispatch => ({
	login: (email, password, xThis) => {
		dispatch(userLogin(email, password, xThis))
	},
	verifyCode: code => {
		dispatch(verifyCode(code))
	},
	loginAD: (token, xThis) => {
		dispatch(userAD(token, xThis))
	},
	logout: () => {
		dispatch(userLogout())
	},
	forgot_password: (email, xThis) => {
		dispatch(forgotPassword(email, xThis))
	},
	first_login: (email, password, newPassword, confirmPassword) => {
		dispatch(firstLogin(email, password, newPassword, confirmPassword))
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(Login))
